import React from "react";
import { UserIcon } from "../../../icons";

const PostPreviewAuthor = props => {
  const { author } = props;
  return (
    <React.Fragment>
      <div className="events-page-post-author">
        <div className="events-page-post-author-logo">
          {author?.profileImage ? (
            <img src={author?.profileImage} alt={`author  ${author?.name}`} />
          ) : (
            <UserIcon />
          )}
        </div>
        <div className="events-page-post-author-content">
          <div className="events-page-post-author-name">{author?.name}</div>
          {author?.jobTitle || author?.work ? (
            <div className="events-page-post-author-text">
              {author?.jobTitle} at {author?.work}
            </div>
          ) : null}
        </div>
      </div>
    </React.Fragment>
  );
};

export default PostPreviewAuthor;
